import React from "react";

import { Index } from "../components/Career/Index";

export const Career = () => {
  return <Index />;
};
